import MCoinLists from "@app/mobile/components/MCoinLists";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { MText } from "@/styles/mobilePageStyles";
import { ThemeContext } from "@/theme/ThemeProvider";
import { MSearchListSection } from "./styles";
import { useExchangeStore } from "../../../../hooks/trade/exchangeStore";
import {ListColumn} from "@/styles/Qstyle.ts";
import CoinList from "@app/mobile/components/MobileSearch/MSearchHot/molecules/CoinList";
import {MSearchHotSection} from "@app/mobile/components/MobileSearch/MSearchHot/styles.tsx";
import styled from "styled-components";
import {media} from "@/styles/Qtheme.ts";
import {MobileCalVW} from "@utils/CalVW.tsx";

const MSearchLists = ({ search }) => {


  const { EPs } = useExchangeStore();

  let filteredData: any;
  if (search?.length) {
    filteredData = EPs?.filter((item) =>
      item?.symbol?.toLowerCase()?.includes(search?.toLowerCase())
    );
  }
  return (
    <MSearchListSection>
      <MSearchHotSection>
        <Title >
          Search
        </Title>

        <ListColumn>
          {filteredData &&
            filteredData?.slice(0, 5)?.map((el, index) => (
              <CoinList key={index} data={el} trade />
            ))}
        </ListColumn>
      </MSearchHotSection>
    </MSearchListSection>
  );
};

export default MSearchLists;

const Title = styled.div`
    font-size: 15px;
    font-weight: 500;
    color: ${({ theme }) => theme.text};
    font-family: "Pretendard",sans-serif;
    padding: 12px 20px;

    @media ${media.mobile} {
        font-size: ${MobileCalVW(15)};
    }
`